import Keycloak from 'keycloak-js';

const IdentityUpdatedAction = 'IDENTITY_UPDATED';
const PermissionUpdatedAction = 'PERMISSION_UPDATED';

const initialState = {
    auth: null,
    idtoken: null,
    token: null,
    username: null,
    permissions: null,
    userData: null,
    isAuthenticated: false
};

export const actionCreators = {
    login: () => async (dispatch) => {
        const keycloak = Keycloak(process.env.REACT_APP_KEYCLOAK_JSON);

        keycloak.init({ onLoad: 'login-required' }).then(authenticated => {
            if (authenticated) {
                var idToken = keycloak.idTokenParsed;

                dispatch({
                    type: IdentityUpdatedAction,
                    auth: keycloak,
                    idToken: keycloak.idToken,
                    token: keycloak.token,
                    userid: idToken.sub,
                    username: idToken.preferred_username,
                    email: idToken.email,
                    isAuthenticated: true
                });
            }
        });
    },
    logout: (auth) => async (dispatch) => {
        var keycloak = auth;
        keycloak.logout();
    },
    getMe: (token) => async (dispatch) => {
        const routeurl = `api/user/identity/me`;
        let response = await fetch(routeurl, {
            method: 'get',
            headers: {
                "Authorization": "Bearer " + token,
                'Content-type': 'application/json; charset=UTF-8'
            },
        })
        const resultStatus = response.status;

        if (resultStatus == 200) {
            const userData = await response.json();
            //console.log("userData.role="+userData.role);
            dispatch({ type: PermissionUpdatedAction, permissions: userData.permissions, userData: userData });
            return userData;
        }
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === IdentityUpdatedAction) {

        return {
            ...state,
            auth: action.auth,
            token: action.token,
            idToken: action.idToken,
            userid: action.id,
            username: action.name,
            email: action.email,
            isAuthenticated: action.isAuthenticated
        };
    }
    if (action.type === PermissionUpdatedAction) {

        return {
            ...state,
            permissions: action.permissions,
            userData: action.userData
        };
    }

    return state;
};
